import { c as _c } from "react/compiler-runtime";
import type { Person } from "@/types/movies";
import { slugify } from "@/lib/slugify";
import { isCastLikeRole } from "@/lib/roleLabels";
interface Props {
  stars: Person[];
}
export default function MovieCredits(t0) {
  const $ = _c(18);
  const {
    stars
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== stars) {
    const actors = stars.filter(_temp).slice(0, 3);
    const authors = stars.filter(_temp2);
    t4 = "mt-10 space-y-3 text-xs sm:text-sm text-gray-300 max-w-[500px]";
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <span className="font-medium">بازیگران:</span>;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    const t7 = actors.length > 0 ? actors.map((actor, i) => {
      const label = actor.name_fa ?? actor.name_en ?? "\u2014";
      const nameSlug = slugify(actor.name_en || actor.name_fa);
      const href = actor.uuid ? `/crew/${actor.uuid}${nameSlug ? `/${nameSlug}` : ""}` : "#";
      const key = actor.uuid ?? `${label}-${i}`;
      return <span key={key}><a href={href} className="hover:underline">{label}</a>{i < actors.length - 1 && "\u060C "}</span>;
    }) : <span>-</span>;
    if ($[7] !== t7) {
      t5 = <div className="hidden lg:flex flex-wrap gap-x-1">{t6}{t7}</div>;
      $[7] = t7;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t1 = "hidden lg:flex flex-wrap gap-x-1";
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span className="font-medium">کارگردان:</span>;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t3 = authors.length > 0 ? authors.map((author, i_0) => {
      const label_0 = author.name_fa ?? author.name_en ?? "\u2014";
      const nameSlug_0 = slugify(author.name_en || author.name_fa);
      const href_0 = author.uuid ? `/crew/${author.uuid}${nameSlug_0 ? `/${nameSlug_0}` : ""}` : "#";
      const key_0 = author.uuid ?? `${label_0}-${i_0}`;
      return <span key={key_0}><a href={href_0} className="hover:underline">{label_0}</a>{i_0 < authors.length - 1 && "\u060C "}</span>;
    }) : <span>-</span>;
    $[0] = stars;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t6 = <div className={t1}>{t2}{t3}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp2(person_0) {
  return person_0.role?.includes("directors");
}
function _temp(person) {
  return isCastLikeRole(person.role);
}